import { Skeleton } from '@progress/kendo-react-indicators';

const LoadingCell = (props) => {
  return (
    <td style={props.style} className={props.className}>
      {' '}
      <Skeleton shape={'text'} style={{ width: '100%' }} />
    </td>
  );
};

export default LoadingCell;
